<template>
	<div class="page__intro-page" key="introPage">
		<div class="back-to-home rounded d-none d-sm-block">
			<a href="index.html" class="btn btn-icon btn-soft-primary">
				<font-awesome-icon icon="home" />
			</a>
		</div>
		<section class="d-flex flex-column align-items-center">
			<div class="container">
				<div class="row align-items-center">
					<div class="col px-0 px-md-2">
						<div class="page__data-enter__image-wrapper" v-if="currentProject.intro_img">
							<img
								:src="helperImgPath(currentProject.intro_img)"
								class="img-fluid d-block mx-auto mt-4"
								:alt="currentProject.title"
							/>
						</div>
						<div class="page__data-enter__image-wrapper" v-else>
							<img
								src="@/assets/images/illustrator/Mobile_notification_SVG.svg"
								class="img-fluid d-block mx-auto mt-4"
							/>
						</div>
					</div>
				</div>
				<div class="row my-4">
					<div class="col">
						<div v-html="currentProject.intro_text"></div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<b-button variant="primary" size="lg" class="mt-3" @click="proceed()">Pričnite z vprašanji</b-button>
					</div>
					<!--end col-->
				</div>
				<!--end row-->
				<ProgressBarContainer
					v-if="
						currentPackage &&
						packageProjectOrder &&
						packageProjectOrder < packageLength
					"
				>
					<template #header>
						<p>
							Sklop
							<span>{{ packageProjectOrder + 1 }}</span>
							od
							{{ packageLength }}
						</p>
					</template>
					<template #bar>
						<b-progress
							:value="packageProjectOrder + 1"
							:max="packageLength"
							height="0.5rem"
							variant="primary"
							class="rounded"
						></b-progress>
					</template>
				</ProgressBarContainer>
			</div>
			<!--end container-->
		</section>
		<!--end section-->
	</div>
</template>
<script>
import ProgressBarContainer from "@/components/ProgressBarContainer.vue"
import { mapGetters } from "vuex"
import moment from "moment"
moment.locale("en")
export default {
	components: {
		ProgressBarContainer
	},
	data() {
		return {
			loading: true,
		}
	},
	computed: {
		...mapGetters({
			respondentId: "api/getRespondentId",
			currentProject: "api/getCurrentProject",
			currentPackage: "api/getCurrentPackage",
			packageProjects: "api/getPackageProjects",
			packageProjectOrder: "api/getPackageCurrentProjectOrder",
			packageLength: "api/calcPackageLength",
		}),
	},

	created() {
		if (this.currentPackage) {
			this.$store.commit("api/quizResetSequence")
			this.$store.commit("api/resetMatchupOrder")
			this.$store.commit("api/quizResetProgress")
		}
	},
	mounted() { },
	methods: {
		proceed: function () {
			let projectSlug = this.$route.params.projectSlug
			let packageSlug = this.$route.params.packageSlug

			// not a package, just a project:
			//this.$store.commit("api/quizAddProgress");

			if (this.respondentId) {
				// PROJECT IN PACKAGE
				if (this.currentPackage && this.packageProjects) {
					this.$router.push({
						name: "PackageMatchup",
						params: {
							packageSlug: packageSlug,
							// is there a current project? If not, take the first one from package
							projectSlug: this.currentProject
								? this.currentProject.random_slug
								: this.packageProjects[0].data.random_slug,
						},
					})
				} else {
					if (this.$route.params.packageSlug) {
						this.$router.push({
							name: "Package",
							params: { packageSlug: packageSlug },
						})
					} else {
						this.$router.push({
							name: "Matchup",
							params: { projectSlug: projectSlug },
						})
					}
				}
			} else {
				if (this.$route.params.packageSlug) {
					this.$router.push({
						name: "Package",
						params: { packageSlug: packageSlug },
					})
				} else {
					this.$router.push({
						name: "DataEnter",
						params: { projectSlug: projectSlug },
					})
				}
			}
		},
		helperImgPath: function (img) {
			return `${this.$store.state.api.url}/uploads/${this.$store.state.api.currentProject.id}/help_images/${img}`
		},
	},
}
</script>
